import { Component, OnInit } from '@angular/core';
import { FileService } from '../../shared/_services/file.service';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-payments-cancellations',
  templateUrl: './payments-cancellations.component.html',
  styleUrls: ['./payments-cancellations.component.css']
})
export class PaymentsCancellationsComponent implements OnInit {

  error: string;
  success: any;
  totalCount: any;
  correctCount: any;

  showButton: boolean = false;

  constructor(
    private fileUploadService: FileService,
  ) { }

  ngOnInit() {
  }

  uploadPayments(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (let file of files)
      formData.append(file.name, file);

    this.fileUploadService.uploadFilePayments(formData)
      .subscribe((event: any) => {
        this.error = undefined;
        if (event.type === HttpEventType.Response) {        
          this.showResults(event.body);
        }
      },
        err => {
          this.error = err;
          this.cleanError();
        }
      );
  }
  //uploadCancellations(files) {
  //  if (files.length === 0)
  //    return;

  //  const formData = new FormData();

  //  for (let file of files)
  //    formData.append(file.name, file);

  //  this.fileUploadService.uploadFileCancellations(formData)
  //    .subscribe((event: any) => {
  //      this.error = undefined;
  //      if (event.type === HttpEventType.Response) {
  //        console.log(event);
  //        this.showResults(event.body, false);  
  //      }
  //    },
  //      err => {
  //        this.error = err;
  //      }
  //    );
  //}

  showResults(res: any, payment: boolean = true) {
    if (payment) {
      this.showButton = true;
      this.success = "Estados de pago actualizados correctamente. ";
      setTimeout(() => {
        this.success = "";
      }, 7000);
    } else {
      this.showButton = true;
      this.success = "Estados de cancelacion actualizados correctamente. ";
      setTimeout(() => {
        this.success = "";
      }, 7000);
    }
  }

  downloadFeedback(payment: boolean = true) {
    this.fileUploadService.downloadFeedbackP_C("Resultado.xlsx", payment);
  }

  cleanError() {
    setTimeout(() => {
      this.error = "";
    }, 7000);
  }
}
